"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _kx = require("@/api/kx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'KxPayment',
  data: function data() {
    return {
      timeVal: [],
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        status: '0',
        orderNo: '',
        uidPhone: '',
        dateLimit: '',
        page: 1,
        limit: 20
      },
      detailDialogVisible: false,
      detailData: null
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    handleTabClick: function handleTabClick() {
      this.getList(1);
    },
    handleReset: function handleReset() {
      this.tableFrom.status = '0';
      this.tableFrom.orderNo = '';
      this.tableFrom.uidPhone = '';
      this.tableFrom.dateLimit = '';
      this.tableFrom.page = 1;
      this.timeVal = [];
      this.getList(1);
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.getList(1);
    },
    getList: function getList(num) {
      var _this = this;
      this.listLoading = true;
      this.tableFrom.page = num || this.tableFrom.page;
      (0, _kx.kxPaymentListApi)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handleReview: function handleReview(id, approved) {
      var _this2 = this;
      if (!approved) {
        this.$prompt('请输入拒绝原因', '拒绝支付审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPlaceholder: '请输入拒绝原因',
          inputValidator: function inputValidator(value) {
            return !!value || '请输入原因';
          }
        }).then(function (_ref) {
          var value = _ref.value;
          (0, _kx.kxPaymentReviewApi)({
            id: id,
            approved: false,
            adminRemark: value
          }).then(function () {
            _this2.$message.success('已拒绝');
            _this2.getList();
          });
        }).catch(function () {});
      } else {
        this.$confirm('审核通过后订单将标记为已支付并触发消费后处理链路（赠送开心果、等级检查、直推奖等），确认通过？', '审核通过', {
          type: 'warning'
        }).then(function () {
          (0, _kx.kxPaymentReviewApi)({
            id: id,
            approved: true,
            adminRemark: ''
          }).then(function () {
            _this2.$message.success('审核通过');
            _this2.getList();
          });
        }).catch(function () {});
      }
    },
    handleDetail: function handleDetail(id) {
      var _this3 = this;
      (0, _kx.kxPaymentDetailApi)(id).then(function (res) {
        _this3.detailData = res;
        _this3.detailDialogVisible = true;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};